<template>
  <div id="main" class="index">
    <topNav></topNav>
    <div class="lawcDetail">
      <div class="backconbox">
        <div
          class="backcon"
          @mouseenter="mosein"
          @mouseout="mouseout"
          @click="backfun"
        >
          <img class="backconImg" :src="imgsrc" alt="" />
          <span class="backconSpan">返回资讯中心</span>
        </div>
      </div>
      <p ref="inlineTitle" class="inline-title" v-html="html.title"></p>
      <div class="inline-html" v-html="html.html"></div>
    </div>
    <Bottoms></Bottoms>
  </div>
</template>
<script>
import topNav from "./sub/topNav";
import Bottoms from "./sub/Bottoms";
export default {
  name: "informatDetail",
  components: { topNav, Bottoms },
  data() {
    return {
      imgsrc: require("@/common/images/lawColumn/backicon.png"),
      html: "",
    };
  },
  mounted() {
    window.scrollTo(0, 0);
    this.initfun(this.$route.query.id);
    // this.$refs.inlineTitle
    // console.log(this.$refs.inlineTitle.innerHTML, "90909");
    // let titles = document.getElementsByClassName("inline-title");
    // console.log(titles[0], "2");
    // console.log(this.$refs.inlineTitle, "6666666666");
  },
  // onUpdated(){

  // },
  methods: {
    initfun: function (id) {
      this.$api.viewZX(id).then((res) => {
        if (res.code == 0) {
          this.html = res.data;
          let titles = document.getElementsByClassName("inline-title");
          // 使用DOMParser将字符串转换为DOM元素
          let parser = new DOMParser();
          let doc = parser.parseFromString(this.html.html, "text/html");
          // 全局前置守卫
          // this.$router.beforeEach((to, from, next) => {
          //   if (to.name == "informatDetail") {
          document.title = this.html.title || "默认标题";

          const keywords = document.querySelector('meta[name="keywords"]');
          keywords.setAttribute("content", this.html.title);
          const description = document.querySelector('meta[name="description"]');
          description.setAttribute("content", doc.getElementsByTagName('p')[0].innerText);

          // console.log(this.html, "2");
          // console.log(doc.getElementsByTagName('p')[0].innerText,'5');
          //   }
          //   next();
          // });
        }
      });
    },
    backfun: function () {
      var information = localStorage.getItem("information")
        ? localStorage.getItem("information")
        : "xxxx";
      if (information != "xxxx") {
        var json = JSON.parse(information);
        if (json.showHistory == 2) {
          json.showHistory = 3;
          var obj = JSON.stringify(json);
          localStorage.setItem("information", obj);
        }
      }
      // this.$router.back();
      this.$router.push({ path: "/information" });
    },
    mosein: function () {
      this.imgsrc = require("@/common/images/lawColumn/backiconr.png");
    },
    mouseout: function () {
      this.imgsrc = require("@/common/images/lawColumn/backicon.png");
    },
  },
};
</script>
<style scoped>
* {
  text-align: left;
}
.index {
  background: rgba(244, 244, 244, 1);
}
.lawcDetail {
  width: 1100px;
  overflow: hidden;
  opacity: 1;
  margin: 0 auto;
  min-height: 536px;
  background: rgba(255, 255, 255, 1);
}
.backconbox {
  width: 100%;
  overflow: hidden;
}
.backcon {
  display: inline-block;
  float: left;
  width: auto;
  height: 22px;
  overflow: hidden;
  line-height: 22px;
  margin: 0 24px;
  box-sizing: border-box;
  margin-top: 24px;
  margin-bottom: 26px;
  cursor: pointer;
}
.backcon:hover .backconSpan {
  color: #e7413b;
}

.backcon span {
  height: 22px;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 22px;
  color: #666666;
  opacity: 1;
  padding-left: 12px;
}
.backcon img {
  padding: 2px 0;
}
.backcon span,
.backcon img {
  display: inline-block;
  float: left;
}
.inline-html {
  width: 676px;
  overflow: hidden;
  margin: 0 auto 60px;
}
.inline-title {
  width: 676px;
  margin: 0 auto 0px;
  overflow: hidden;
  text-align: center;
  font-family: "宋体";
  font-weight: 900;
  line-height: 50px;
  font-size: 24px;
  margin-bottom: 20px;
}
</style>


// WEBPACK FOOTER //
// src/components/informatDetail.vue